import React from 'react'
import {Trans} from 'react-i18next'

import {
  FormControl,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import {RatingTableQuestion} from '@progyny/pages/Consultations/components/questions/types'

const ratingTableStyles = {
  container: {
    border: '1px solid #D6D8E0',
    borderRadius: '4px',
    boxShadow: 'none',
  },
  table: {
    '& .MuiTableCell-root': {
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: '1px solid #D6D8E0',
    },
  },
  headerRow: {
    backgroundColor: '#F3F4F6',
  },
  headerCell: {
    backgroundColor: '#F3F4F6',
    whiteSpace: 'nowrap',
    fontWeight: 600,
    borderBottom: '1px solid #D6D8E0',
  },
  bodyRow: {
    '&:last-child .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
}

interface RatingTableQuestionRendererProps {
  question: RatingTableQuestion
  formData: Record<string, string>
  handleInputChange: (questionId: string, value: string) => void
  isSubmitting: boolean
}

const RatingTableQuestionRenderer: React.FC<
  RatingTableQuestionRendererProps
> = ({question, formData, handleInputChange, isSubmitting}) => (
  <FormControl component='fieldset' fullWidth>
    {question.description && (
      <Typography
        variant='body2'
        color='text.secondary'
        mb={2}
        textAlign='center'
      >
        <Trans>{question.description}</Trans>
      </Typography>
    )}
    <TableContainer component={Paper} sx={ratingTableStyles.container}>
      <Table sx={ratingTableStyles.table}>
        <TableHead>
          <TableRow sx={ratingTableStyles.headerRow}>
            <TableCell
              sx={{
                ...ratingTableStyles.headerCell,
                maxWidth: '300px',
                whiteSpace: 'normal',
              }}
            >
              <Trans>{question.title}</Trans>
            </TableCell>
            {question.columns.map((col) => (
              <TableCell
                key={col.value}
                align='center'
                sx={{
                  ...ratingTableStyles.headerCell,
                  maxWidth: '140px',
                  whiteSpace: 'normal',
                }}
              >
                <Trans>{col.label}</Trans>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {question.items.map((item) => {
            const fieldId = `${question.id}_${item.id}`
            return (
              <TableRow key={item.id} sx={ratingTableStyles.bodyRow}>
                <TableCell>{item.label}</TableCell>
                {question.columns.map((col) => (
                  <TableCell key={col.value} align='center'>
                    <Radio
                      checked={formData[fieldId] === col.value}
                      onChange={() => handleInputChange(fieldId, col.value)}
                      disabled={isSubmitting}
                    />
                  </TableCell>
                ))}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </FormControl>
)

export default RatingTableQuestionRenderer
